import useOnDocumentFileNameEdit from './useOnDocumentFileNameEdit';

export default useOnDocumentFileNameEdit;